<template>
  <div class="apple-login-callback">
    <p class="titlu_apple">Te autentificăm...</p>

    <!-- FORM VIZIBIL pentru debug -->
    <form method="post">
      <input type="hidden" name="code" />
      <input type="hidden" name="id_token" />
    </form>
    <div class="alerta_generala alerta_verde modal_autentificare_facebook"><i class="ri-checkbox-circle-line"></i>{{ $t('autentificare_succes') }}</div>
  </div>
</template> 

<script>
import axios from 'axios';
import $ from 'jquery'
 
export default {
  mounted() {
    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');
    const idToken = params.get('id_token');
    const email = params.get('email');
    const appleId = params.get('apple_id');
    const firstName = params.get('first_name');
    const lastName = params.get('last_name');

    console.log('Login Apple:', { code, idToken, email, appleId });

    if (code && idToken && email && appleId) {
      axios.post(
        'https://xpanel.tikibistro.ro/api/auth/login_with_apple',
        {
          code,
          id_token: idToken,
          email,
          apple_id: appleId,
          first_name: firstName,
          last_name: lastName,
        },
        {
          withCredentials: false, // necesar pentru CORS (dacă nu folosești cookies)
        }
      )
      .then(res => {
        // Salvează token-ul primit (presupunem că vine ca în login_facebook)
        localStorage.setItem('token', res.data.data[0].token);
        this.$store.commit("setUser", res.data.data[0].user.email);
        console.log('Login Apple successful:', res);

        // Animatii pentru mobile vs desktop
        const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        $('.modal_autentificare_facebook').animate({ "right": isMobile ? "10px" : "20px" }, "slow");

        // Ascunde după 2 secunde
        setTimeout(() => {
          $('.modal_autentificare_facebook').animate({ "right": isMobile ? "-1000px" : "-100vw" }, "slow");
        }, 2000);

        // Redirectează către homepage după 1.5 secunde
        setTimeout(() => {
          this.$router.push('/');
        }, 1500);
      })
      .catch(err => {
        console.error('Login Apple error:', (err.response && err.response.data) || err.message);
      });
    } else {
      console.warn('Datele Apple lipsesc sau sunt incomplete:', { code, idToken, email, appleId });
    }
  },
  methods: {
    
    
  }
}
</script>